import React, { useState } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';

export default function Meetings(){
  const [openIndex, setOpenIndex] = useState(null);
  const meetings = [
    {
      title: 'Worship',
      time: 'Sundays 9:30am',
      description: 'Join us for worship and teaching from God’s Word.',
      icon: '/icons/worship.png'
    },
    {
      title: 'Sunday School/ Second Meeting',
      time: 'Sundays 11:50am',
      description: 'Bible teaching for children and adults to grow in faith.',
      icon: '/icons/sundayschool.png'
    },
    {
      title: 'Bible Study',
      time: 'Saturdays 6:30pm',
      description: 'Interactive Bible study and fellowship.',
      icon: '/icons/BibleStudy.png'
    },
    {
      title: 'Prayer',
      time: 'Wednesdays 8:30pm (Online)',
      description: 'Midweek prayer and encouragement.',
      icon: '/icons/prayer.png'
    }
  ];

  return (
    <>
      <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
          <div className="text-center mb-4">
            <h2 className="fw-bold mb-3" style={{ fontSize: '3.425rem', color: '#c53607f5' }}>Our Meetings</h2>
          </div>
          <Row className="g-2">
            {meetings.map((service, index) => (
              <Col key={index} xs={12} sm={6} lg={3}>
                <Card className="h-100" style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', display: 'flex', flexDirection: 'column', border: '4px solid rgba(255,255,255,0.2)', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', transition: 'transform 0.2s, box-shadow 0.2s', paddingBottom: '10px' }} onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)'; setOpenIndex(index); }} onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; setOpenIndex(null); }}>
                  <Card.Img src={service.icon} variant="top" style={{ height: '140px', objectFit: 'contain', padding: '12px 12px 0' }} />
                  <Card.Body className="text-center" style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0.5rem', color: '#c53607f5' }}>
                    <Card.Title className="h6 fw-bold mb-2" style={{ fontSize: '1.625rem' }}>{service.title}</Card.Title>
                    <Card.Text style={{ fontSize: '1.525rem', lineHeight: '1.4' }}>{service.time}</Card.Text>
                    {openIndex === index && (
                      <Card.Text style={{ fontSize: '1.525rem', lineHeight: '1.4', marginTop: '8px' }}>{service.description}</Card.Text>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </>
  );
}
  